module.exports = __webpack_public_path__ + "static/img/knowledgenew1.1ae0817e.jpg";